import { PURPLE_60, GRAY_60, WHITE } from 'ui-kit/GlobalStyle/colors';
import { APP_FONT_FAMILY } from 'ui-kit/GlobalStyle/appFontFamily';
import styled, { css } from 'styled-components';

const textStyles = css`
    font-size: 12px;
    font-style: normal;
    font-weight: 500;
    line-height: 19px;
    align-items: center;
`;

export const dataPickerStyles = css`
    .date_picker.full-width {
        width: 100%;
    }
    div > .react-datepicker {
        border: 0;
        border-radius: 7px;
        box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.1);
    }
    .react-datepicker__triangle {
        display: none;
    }
    .react-datepicker__tab-loop > .react-datepicker-popper {
        margin: 0;
    }
    .react-datepicker-popper {
        z-index: 30;
    }
    .react-datepicker__month-container > .react-datepicker__header {
        background-color: ${WHITE};
        border: 0;
    }
    .react-datepicker__header > .react-datepicker__current-month {
        font-family: ${APP_FONT_FAMILY};
        font-size: 16px;
        font-style: normal;
        font-weight: 500;
        line-height: 25px;
        letter-spacing: 0em;
        text-align: center;
    }
    .react-datepicker__week > .react-datepicker__day,
    .react-datepicker__day-names > .react-datepicker__day-name {
        border-radius: 8px;
        ${textStyles};
    }
    .react-datepicker__day--weekend {
        color: #d55142;
    }
    .react-datepicker__month-container > .react-datepicker__month {
        margin: 0;
    }
    .react-datepicker__month-container {
        padding: 14px 29px;
        padding-top: 2px;
    }
    .react-datepicker__day--selected,
    .react-datepicker__day:hover,
    .react-datepicker__day--keyboard-selected,
    .react-datepicker__day--in-range {
        background-color: ${PURPLE_60};
        box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.17);
        outline: none;
        color: ${WHITE};
    }
    .react-datepicker__navigation--next,
    .react-datepicker__day--outside-month {
        color: #c4c4c4;
    }
    .react-datepicker__day--in-selecting-range,
    .react-datepicker__month-text--in-selecting-range,
    .react-datepicker__quarter-text--in-selecting-range,
    .react-datepicker__year-text--in-selecting-range {
        background-color: #e1d4f3;
        border-radius: 50%;
    }
    .react-datepicker__month-container {
        font-family: ${APP_FONT_FAMILY};
    }
    .react-datepicker__navigation::before {
        border-color: #ccc;
        border-style: solid;
        border-width: 3px 3px 0 0;
        content: '';
        display: block;
        height: 10px;
        width: 10px;
    }
    .react-datepicker__navigation--previous {
        transform: rotate(-132deg);
    }
    .react-datepicker__navigation--next {
        transform: rotate(46deg);
    }
    .react-datepicker__navigation-icon {
        display: none;
    }
`;

export const DatePickerContainer = styled.div`
    display: flex;
    flex-direction: column;
    border: 1px solid ${GRAY_60};
    border-radius: 10px;
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: 22px;
    padding: 13px 15px;
    height: 48px;
`;

export const PlaceholderSpan = styled.span`
    color: #ced1da;
    font-size: 16px;
`;
